import { Button } from "@mui/material";
import { useCallback } from "react";
import { useGenerateQualityReviewLinkMutation } from "src/api/services/api";

interface Props {
  patientEmail: string;
  buttonText: string;
}

const MagicLinkButton = ({ patientEmail, buttonText }: Props) => {
  const [generateQualityReviewLink] = useGenerateQualityReviewLinkMutation();

  const handleQualityReviewLink = useCallback(async () => {
    const link = await generateQualityReviewLink({
      patientEmail: patientEmail,
      redirectTo: `${import.meta.env.VITE_REDIRECT_LINK}/quality-review`,
    });

    window.open(link.data, "_blank");
  }, [generateQualityReviewLink, patientEmail]);

  return (
    <Button onClick={handleQualityReviewLink} variant="contained">
      {buttonText}
    </Button>
  );
};

export default MagicLinkButton;
